import React, { FormEvent, useState } from 'react'

import { SupplierBrand } from '../../../models'
import { UpdateCountryParams } from '../../../api'

interface FormProps {
    handleSubmit: (
        e: FormEvent<HTMLFormElement>,
        inputs: UpdateCountryParams
    ) => void
    supplierBrand?: SupplierBrand
}

export const SupplierBrandForm = (props: FormProps) => {
    const { handleSubmit, supplierBrand } = props

    const defaultInputs = {
        name: supplierBrand?.name
    }

    const [inputs, setInputs] = useState(defaultInputs)

    const updateInputs = (field: string, value: number | string) => {
        setInputs({
            ...inputs,
            [field]: value
        })
    }

    return (
        <form onSubmit={(e) => handleSubmit(e, inputs)}>
            <div className='row mb-4'>
                <div className='col-12'>
                    <label htmlFor='nameInput'>Brand Name</label>
                    <input
                        className='form-control'
                        id='nameInput'
                        onChange={(e) => updateInputs(
                            'name',
                            e.target.value
                        )}
                        required
                        type='text'
                        value={inputs.name} />
                </div>
            </div>
            <div className='row mb-5'>
                <div className='col-12 d-flex justify-content-center'>
                    <button className='btn btn-primary' type='submit'>
                        Submit
                    </button>
                </div>
            </div>
        </form>
    )
}
